import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify';
import ReactHtmlParser from 'react-html-parser'; 
import QrScanner from 'components/QrScanner';


import LoaderButton from "../components/LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

// import "../../node_modules/noty/lib/noty.css";
// import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
// import "./Show.css";

export default function ShowStats({show, ...props}) {
    
  //const file = useRef(null);
  const { id } = useParams();
  const history = useHistory();

  const [tickets, setTickets] = useState([]);  
  const [isLoading, setIsLoading] = useState(false);  


    useEffect(() => {
        async function onLoad() {
            try {           
                setIsLoading(true)

                loadSalesSummary()    

            } catch (e) {
                onError(e);
            } finally {
                setIsLoading(false)
            }
        }

        onLoad();
    }, [show]);
    

    async function loadSalesSummary() {
        try {
            setIsLoading(true)

            const tickets = await API.get("vivelo", `/viewers/sales/summary/${show._id}?paymentDetail=0`);
            if (tickets && tickets.items && tickets.items.length > 0) {            
                setTickets(tickets.items)
            } else {
                setTickets([])
            }
            return tickets
        } finally {
            setIsLoading(false)
        }
    }

    function renderPaymentType(type) {
        switch(type) {
            case 'CREDIT_CARD':
                return 'TC/TD'
            case 'BANK_DEPOSIT':
            case 'ACCOUNT_BANK_DEPOSIT':
                return 'ACH'
            case 'REGISTRATION':
                return 'REG'
            case 'CASH':
                return 'EFE'
            case 'POS':
                return 'POS'
            default:
                return 'OTR'
        }

    }
    
    function renderShowTicketsData(show, tickets) {
        const items = []
        let totalSold = 0
        let totalNetSold = 0
        let totalActivated = 0
        let totalCheckedin = 0
        let total = 0
        let currency = 'Q'        

        tickets.forEach( t => {
            currency = t.currency == 'USD' ? 'US$' : 'Q'
            const price = t.currency == 'USD'
                ? (t.discount_price_usd > 0 ? t.discount_price_usd : t.price_usd) 
                : (t.discount_price > 0 ? t.discount_price : t.price)
            const soldPrice = t.currency == 'USD' ? t.soldPrice_usd : t.soldPrice

            if (t.currency == 'USD') {
                totalSold += t.sold
                totalNetSold += t.netSold || t.sold
                totalActivated += t.activated
                totalCheckedin += t.checkedin || 0
                total += price * t.sold
            } else {
                totalSold += t.sold
                totalNetSold += t.netSold || t.sold
                totalActivated += t.activated
                totalCheckedin += t.checkedin || 0
                total += price * t.sold
            }
            items.push(<tr key={t.ticket_uid} >
                <td>{t.fullname  }{t.note ? <div className="note">{t.note}</div> : null }</td>
                {/* <td>{renderPaymentType(t.payment_type)}</td> */}
                {/* <td style={{textAlign:'right'}}>{currency} {price.toFixed(2)}</td> */}
                <td style={{textAlign:'right',whiteSpace:'nowrap'}}>{t.checkedin || 0} / {t.sold}{t.netSold != t.sold ? ` (${t.netSold})` : ``}</td>
                {/* <td style={{textAlign:'right'}}>{t.activated || 0}</td> */}
                {/* <td style={{textAlign:'right'}}></td>                 */}
                
            </tr>)
        })
        
        items.push(<tr key={`total-${show._id}`}>
            <td colSpan="1" style={{fontWeight:'bold'}}>TOTAL</td>
                <td style={{textAlign:'right',whiteSpace:'nowrap',fontWeight:'bold'}}>{totalCheckedin} /{totalSold}{totalNetSold != totalSold ? ` (${totalNetSold})` : ``}</td>
                {/* <td style={{textAlign:'right'}}>{totalActivated}</td> */}
                {/* <td style={{textAlign:'right'}}></td>                 */}
        </tr>)

        

        return items
    }

    function getTotals(show, tickets) {

        let totalSold = 0
        let totalNetSold = 0
        let totalActivated = 0
        let totalCheckedin = 0

        tickets.forEach( t => {
            if (t.currency == 'USD') {
                totalSold += t.sold
                totalNetSold += t.netSold || t.sold
                totalActivated += t.activated
                totalCheckedin += t.checkedin || 0
            } else {
                totalSold += t.sold
                totalNetSold += t.netSold || t.sold
                totalActivated += t.activated
                totalCheckedin += t.checkedin || 0
            }
        })

        return {
            totalSold: totalSold,
            totalNetSold: totalNetSold,
            totalActivated: totalActivated,
            totalCheckedin: totalCheckedin
        }

    }
    
    function renderTotalsTable() {

        const totals = getTotals(show, tickets)

        return <>
            { !isLoading && <Table responsive striped bordered hover variant="dark">
                <tr><td><b>Vendidos</b></td><td>{totals.totalSold || 0}{totals.totalNetSold != totals.totalSold ? ` (${totals.totalNetSold})` : ``}</td></tr>
                {/* <tr><td><b>Activados</b></td><td>{totals.totalActivated || 0}</td></tr> */}
                <tr><td><b>Admitidos</b></td><td>{totals.totalCheckedin || 0}</td></tr>
            </Table>}                   
            </>

    }

    function renderTicketsTable() {

        let items = [];
        // let totalSold = 0
        // let totalActivated = 0        
        let currency = 'Q'        

        items.push(renderShowTicketsData(show, tickets))

        return <>
            <Table responsive striped bordered hover variant="dark">
                <thead>
                    <tr>
                        <th>Boleto</th>
                        {/* <th>Pago</th> */}
                        {/* <th>Precio</th> */}
                        {/* <th>Vendidos</th> */}
                        {/* <th>Activados</th> */}
                        <th>Admitidos</th>
                    </tr>
                </thead>
                <tbody>
                    {!isLoading && items}
                </tbody>
            </Table>            
            </>

    }

    function renderSalesSummary() {        

        return <>
        <div className="container show-tickets">
                <LoaderButton onClick={loadSalesSummary} isLoading={isLoading} variant="info" size="sm" >Actualizar</LoaderButton>
                <br /><br />
                <>{renderTotalsTable()}</>
                <br />
                <>{renderTicketsTable()}</>
        
        </div> 
        </>
    }
    
    return (        
        

        show  ? <>
        <div>
            {renderSalesSummary()}
        </div>
        </> : null
  );
}